import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';

import { Api } from '@/shared/api';
import { useCurrentProject } from '@/shared/projects/project-path';

export function useGetPublisher() {
  const project = useCurrentProject();
  const params = useParams();

  const publisherId = Number(params.publisherId);

  return useQuery({
    queryKey: [project, 'publisher', publisherId],
    queryFn: () => Api.publishers.getPublisher(project, publisherId),
    enabled: !!publisherId,
  });
}

export function useGetPublisherBooks() {
  const project = useCurrentProject();
  const params = useParams();

  const publisherId = Number(params.publisherId);

  return useQuery({
    queryKey: [project, 'publisher-books', publisherId],
    initialData: {
      books: [],
      count: 0,
    },
    queryFn: () =>
      Api.books.getBooks(project, { limit: 100, offset: 0, publisherId }),
    enabled: !!publisherId,
  });
}
